import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SyncProcessorService } from '@vending/sync-engine-client';
import { NgxIndexedDBService } from 'ngx-indexed-db';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- app-boundary-backlog
import { CustomerLocationModel } from 'src/app/models/customers/location';
import { ErrorService } from 'src/packages/mitsBasics';
import { EventsService } from 'src/packages/mitsBasics';
import { BufferstockModel } from '../models';
import { StockWithInventoryService } from './StockWithInventory.service';

@Injectable({
  providedIn: 'root',
})
export class BufferstockService extends StockWithInventoryService<BufferstockModel> {
  constructor(
    public indexedDBService: NgxIndexedDBService,
    public syncProcessor: SyncProcessorService,
    public http: HttpClient,
    public errorService: ErrorService,
    public events: EventsService,
  ) {
    super(
      indexedDBService,
      syncProcessor,
      'Warehouse::Bufferstock',
      http,
      errorService,
      events,
      'warehouse/bufferstocks/',
      'warehouse_bufferstock',
      ['created_at', 'updated_at', 'type', 'positions'],
      ['baskets'],
    );
    this.bulkSize = 5;
    this.bulkSyncActive = true;
  }

  /**
   * Name des Icons für die Klasse
   * @return {string}
   */
  public get iconName(): string {
    return 'albums-outline';
  }

  compare(a: CustomerLocationModel, b: CustomerLocationModel): number {
    if (!a.bufferstock_code || !b.bufferstock_code) return 0;
    return a.bufferstock_code
      .toLowerCase()
      .localeCompare(b.bufferstock_code.toLowerCase());
  }
}
